export default "__VITE_PUBLIC_ASSET__96c51723__"